import { ComponentPropsWithoutRef, ReactNode } from 'react'
import styles from '../../styles/common/Button.module.scss'

interface BaseButtonProps extends ComponentPropsWithoutRef<'button'> {
  className?: string
  children?: ReactNode
  onClick?: () => void
}

const BaseButton = ({
  children,
  onClick,
  className = '',
  ...props
}: BaseButtonProps) => {
  return (
    <button onClick={onClick} className={styles.saveButtonContainer} {...props}>
      {children}
    </button>
  )
}

export default BaseButton
